import { API_BASE_PATH } from '@ytclip/shared'
import { createAuthClient } from 'better-auth/react'

/**
 * In development `VITE_API_URL` is empty and Vite proxies `/api` to the server,
 * so the session cookie is same-origin. In production this points at
 * api.ytclip.org and the cookie is scoped to the shared parent domain.
 */
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || window.location.origin,
  basePath: `${API_BASE_PATH}/auth`,
})

export const { useSession, signOut } = authClient

export function signInWithGoogle(callbackPath = '/dashboard'): Promise<unknown> {
  return authClient.signIn.social({
    provider: 'google',
    callbackURL: new URL(callbackPath, window.location.origin).toString(),
  })
}
